import { render, staticRenderFns } from "./FrzCtnPermissionsinProcess.vue?vue&type=template&id=6bb670a5"
import script from "./FrzCtnPermissionsinProcess.vue?vue&type=script&lang=js"
export * from "./FrzCtnPermissionsinProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports